module.exports = __webpack_public_path__ + "static/media/49.96f50244.png";